import type { PluginModule } from './host/load.ts';

// Plugin discovery: every `src/plugins/<feature>/<folder>/src/index.tsx` is a plugin, with
// its `package.json` beside it for its name and version. Found when the app
// is built, so adding a plugin folder needs no list and no restart: the dev
// server picks the new file up. The feature folder above a plugin only groups
// it: the plugin is still known, and ordered, by its own folder's name.
//
// Eager: every plugin is part of the first module graph and sets up before
// the first render, as Piral set every pilet up before showing the screen,
// so gates, rail entries and pages are all registered when anything draws.
// Setups only register; heavy work (the engine, chessground) starts on use.
// A lazy glob would add a request per plugin before setup for no gain.

export const modules = import.meta.glob<PluginModule>('../../../plugins/*/*/src/index.tsx', { eager: true });

export const packages = import.meta.glob<{ name?: string; version?: string }>('../../../plugins/*/*/package.json', {
  eager: true,
  import: 'default',
});
